
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: "notice",
components: {
XHeader
},
data(){
return{
notices:[
{
id:1,
title:'西安科技大学高新学院',
date:'2018.12.23 16:23:30',
author:'赵一',
depart:'教务处',
content:'撒可见度封杀空间的封杀看见对方上的放假啊说得来看见发哈斯达克警方潜入分歧而返回上的VS发动机开放接口的设计方式的看法请问额外分屈饿哦哦阮福厄夫和前',
isview:false
},
{
id:2,
title:'西安科技大学高新学院',
date:'2018.12.23 16:23:30',
author:'赵一',
depart:'教务处',
content:'撒可见度封杀空间的封杀看见对方上的放假啊说得来看见发哈斯达克警方潜入分歧而返回上的VS发动机开放接口的设计方式的看法请问额外分屈饿哦哦阮福厄夫和前'
,isview:false
},
{
id:3,
title:'西安科技大学高新学院',
date:'2018.12.23 16:23:30',
author:'赵一',
depart:'教务处',
content:'撒可见度封杀空间的封杀看见对方上的放假啊说得来看见发哈斯达克警方潜入分歧而返回上的VS发动机开放接口的设计方式的看法请问额外分屈饿哦哦阮福厄夫和前'
,isview:false
},{
id:4,
title:'西安科技大学高新学院',
date:'2018.12.23 16:23:30',
author:'赵一',
depart:'教务处',
content:'撒可见度封杀空间的封杀看见对方上的放假啊说得来看见发哈斯达克警方潜入分歧而返回上的VS发动机开放接口的设计方式的看法请问额外分屈饿哦哦阮福厄夫和前'
,isview:true
},
{
id:5,
title:'西安科技大学高新学院',
date:'2018.12.23 16:23:30',
author:'赵一',
depart:'教务处',
content:'撒可见度封杀空间的封杀看见对方上的放假啊说得来看见发哈斯达克警方潜入分歧而返回上的VS发动机开放接口的设计方式的看法请问额外分屈饿哦哦阮福厄夫和前'
,isview:true
},
]
}
}
}



// WEBPACK FOOTER //
// ./src/components/Notice.vue